export default "__VITE_ASSET__DAf6ngrM__"